import React, { useEffect, useState } from "react";
import contactImg from "../assest/images/contact-us/cloud.webp";
import img1 from "../assest/images/banner-img/1.jpg";
import { apiRequest } from "../services/allApi";
import { errorAlert, successAlert } from "../services/sweetAlert";
import { Link } from "react-router-dom";
import Loader from "../component/loader.jsx";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
function CarTours() {
  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const [homeData, setHomeData] = useState([]);
  const Home = async () => {
    setIsLoading(true);
    try {
      const res = await apiRequest("home");
      setIsLoading(false);
      if (res?.success) {
        setHomeData(res.data);
      } else {
        errorAlert(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    Home();
  }, []);
  // Mobile panel state
  const [mobilePanelOpen, setMobilePanelOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("filter");

  const [open, setOpen] = useState({
    price: true,
    style: true,
    type: true,
    duration: false,
    time: false,
    language: false,
  });

  const [showMore, setShowMore] = useState(false);

  const toggle = (key) => {
    setOpen((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // Recommended packages data
  const recommendedPackages = [
    {
      img: img1,
      title: "Leh-Ladakh Bike Expedition",
      location: "Leh, Nubra Valley",
      price: "₹2,898",
    },
    {
      img: img1,
      title: "Kashmir Great Lakes Trek",
      location: "Srinagar, Sonmarg",
      price: "₹3,500",
    },
    {
      img: img1,
      title: "Spiti Valley Adventure",
      location: "Manali, Kaza",
      price: "₹4,200",
    },
    {
      img: img1,
      title: "Golden Triangle Tour",
      location: "Delhi, Agra, Jaipur",
      price: "₹2,500",
    },
  ];

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Helmet>
        <title>Ladakh Car Tour Packages | Ladakh MotoDrive</title>

        <meta
          name="description"
          content="Explore Ladakh with comfortable car tour packages. Visit Leh, Nubra Valley & Pangong Lake with expert drivers from Ladakh MotoDrive."
        />

        <meta
          name="keywords"
          content="ladakh car tour packages, leh ladakh taxi tour, ladakh cab packages, leh sightseeing car tour, ladakh family tour package, nubra pangong car trip, ladakh motodrive car tour"
        />

        <link
          rel="canonical"
          href="https://ladakhmotodrive.com/ladakh-car-tour-packages"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Ladakh Car Tour Packages | Ladakh MotoDrive"
        />
        <meta
          property="og:description"
          content="Explore Ladakh with comfortable car tour packages. Visit Leh, Nubra Valley & Pangong Lake with expert drivers from Ladakh MotoDrive."
        />
        <meta
          property="og:url"
          content="https://ladakhmotodrive.com/ladakh-car-tour-packages"
        />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Ladakh Car Tour Packages | Ladakh MotoDrive"
        />
        <meta
          name="twitter:description"
          content="Explore Ladakh with comfortable car tour packages. Visit Leh, Nubra Valley & Pangong Lake with expert drivers from Ladakh MotoDrive."
        />
      </Helmet>

      {/* ===== Banner ===== */}
      <div className="container-fulid">
        <div className="cloud-img">
          <div className="cloud-move">
            <img src={contactImg} alt="cloud" />
          </div>
        </div>
        <div className="page-banner page-banner1">
          <div className="main-title">
            <h3 className="breadcrumb-title">Ladakh Car Tour Packages</h3>
            <ul className="breadcrumb-menu">
              <li>
                <a className="text-white" href="index.html">
                  Home
                </a>
              </li>
              <li>-</li>
              <li className="active">Ladakh Car Trip</li>
            </ul>
          </div>
        </div>
      </div>

      {/* ===== CONTENT ===== */}
      <section className="bg-light pt-5 pb-5">
        <div class="search-wrapper">
          <input
            type="text"
            placeholder="Search in Ladakh Bike Expedition | Leh Based Company ..."
            class="search-input"
          />

          <button class="search-btn">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-search"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </button>
        </div>
        <div className="container">
          <div className="row">
            {/* ================= SIDEBAR ================= */}
            <div className="col-lg-4 desktop-sidebar">
              <div className="togo-tour-sidebar mb-30  ">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h4 className="mb-0">Filter</h4>

                  <a href="javascript:void(0);">Clear</a>
                </div>

                {/* PRICE RANGE WIDGET */}
                <PriceRange />

                {/* TOUR STYLES */}
                <Widget
                  title="Tour styles"
                  open={open.style}
                  toggle={() => toggle("style")}
                  items={["Natural", "Cuisine", "Biking", "Family"]}
                />

                {/* TOUR TYPES */}
                <div className="togo-tour-widget">
                  <h4
                    className="togo-tour-widget-title"
                    onClick={() => toggle("type")}
                  >
                    Tour types <span className="icon">⌃</span>
                  </h4>

                  {open.type && (
                    <div className="inner_content">
                      <ul>
                        {[
                          "Group tour",
                          "Private tour",
                          "Daily tour",
                          "Package tour",
                        ].map((item, i) => (
                          <li key={i}>
                            <input type="checkbox" id={item} />
                            <label htmlFor={item}>{item}</label>
                          </li>
                        ))}

                        {!showMore && (
                          <li>
                            <button onClick={() => setShowMore(true)}>
                              Show more
                            </button>
                          </li>
                        )}

                        {showMore && (
                          <>
                            {[
                              "City Tours",
                              "Cultural Tours",
                              "Family Friendly Tours",
                            ].map((item, i) => (
                              <li key={i}>
                                <input type="checkbox" id={item} />
                                <label htmlFor={item}>{item}</label>
                              </li>
                            ))}

                            <li>
                              <button onClick={() => setShowMore(false)}>
                                Show less
                              </button>
                            </li>
                          </>
                        )}
                      </ul>
                    </div>
                  )}
                </div>

                {/* OTHER FILTERS */}
                <Widget
                  title="Duration"
                  open={open.duration}
                  toggle={() => toggle("duration")}
                  items={[
                    "0 - 3 hours",
                    "3 - 5 hours",
                    "5 - 8 hours",
                    "8 - 12 hours",
                  ]}
                />
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="col-lg-8">
              <div className="filter-topbar">
                {/* LEFT SIDE */}
                <div className="filter-left">
                  <span className="tour-count">24 tours found</span>

                  <button className="clear-filter">Clear filter</button>
                </div>

                {/* RIGHT SIDE */}
                <div className="filter-right">
                  <select className="sort-dropdown">
                    <option>Popular</option>
                    <option>Price Low → High</option>
                    <option>Price High → Low</option>
                    <option>Newest</option>
                  </select>
                </div>
              </div>

              <section className="  ">
                <div className="container">
                  {/* Heading */}

                  {/* Cards */}
                  <div className="row g-4">
                    {homeData?.tours
                      ?.filter((item) => item.category_name === "Car")
                      .map((item, index) => (
                        <div className="col-lg-6 col-md-6" key={index}>
                          <div className="package-card">
                            <div className="package-card-img-wrap">
                              <Link
                                to={`/TourDetail/${item.slug}`}
                                className="card-img"
                              >
                                <img
                                  src={`${BASE_URL}${item?.image}`}
                                  alt={item.title}
                                />
                              </Link>

                              <div className="batch">
                                <span className="date">{item.duration}</span>

                                <div className="location">
                                  <ul className="location-list">
                                    <li>
                                      <Link to={`/TourDetail/${item.slug}`}>
                                        Ladakh
                                      </Link>
                                    </li>
                                    <li>
                                      <Link to={`/TourDetail/${item.slug}`}>
                                        {item.tour_type}
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>

                            <div className="package-card-content">
                              <div className="card-content-top">
                                <h5>
                                  <Link to={`/TourDetail/${item.slug}`}>
                                    {item.title}
                                  </Link>
                                </h5>

                                <div className="location-area">
                                  <ul className="location-list scrollTextAni">
                                    {item.location?.split("-").map((loc, i) => (
                                      <li key={i}>
                                        <Link to={`/TourDetail/${item.slug}`}>
                                          {loc.trim()}
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>

                              <div className="card-content-bottom">
                                <div className="price-area">
                                  <h6>Starting From:</h6>

                                  <span>
                                    ₹{item.price} <del>₹{item.mrp}</del>
                                  </span>

                                  <p>TAXES INCL/PERS</p>
                                </div>

                                <Link
                                  className="primary-btn2"
                                  to={`/TourDetail/${item.slug}`}
                                >
                                  Book a ride
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>

      {/* ================= MOBILE PANEL ================= */}
      {/* Mobile Toggle Button */}
      <div className="mobile-panel-toggle d-lg-none">
        <button
          className="mobile-filter-btn"
          onClick={() => setMobilePanelOpen(true)}
          aria-label="Open filters"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
          </svg>
          <span>Filter</span>
        </button>
      </div>

      {/* Mobile Panel Overlay */}
      <div
        className={`mobile-panel-overlay ${mobilePanelOpen ? "active" : ""}`}
        onClick={() => setMobilePanelOpen(false)}
      ></div>

      {/* Mobile Slide Panel */}
      <div className={`mobile-filter-panel ${mobilePanelOpen ? "open" : ""}`}>
        <div className="mobile-panel-header">
          <h3>Filter & Recommend</h3>
          <button
            className="mobile-panel-close"
            onClick={() => setMobilePanelOpen(false)}
            aria-label="Close panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* Tab Navigation */}
        <div className="mobile-panel-tabs">
          <button
            className={`tab-btn ${activeTab === "filter" ? "active" : ""}`}
            onClick={() => setActiveTab("filter")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
            </svg>
            Filter
          </button>
          <button
            className={`tab-btn ${activeTab === "recommend" ? "active" : ""}`}
            onClick={() => setActiveTab("recommend")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
            </svg>
            Recommend
          </button>
        </div>

        {/* Tab Content */}
        <div className="mobile-panel-content">
          {/* Filter Tab Content */}
          {activeTab === "filter" && (
            <div className="filter-content">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <h4 className="mb-0">Filter</h4>
                <a href="javascript:void(0);">Clear</a>
              </div>

              {/* Mobile Price Range */}
              <div className="mobile-price-widget togo-tour-widget">
                <h4 className="togo-tour-widget-title">
                  Price range <span>⌃</span>
                </h4>
                <div className="price-inputs">
                  <div>
                    <label>Min. price</label>
                    <input value="$0" readOnly />
                  </div>
                  <div>
                    <label>Max. price</label>
                    <input value="$2333" readOnly />
                  </div>
                </div>
              </div>

              {/* Mobile Tour Styles */}
              <Widget
                title="Tour styles"
                open={open.style}
                toggle={() => toggle("style")}
                items={["Natural", "Cuisine", "Biking", "Family"]}
              />

              {/* Mobile Tour Types */}
              <div className="togo-tour-widget">
                <h4
                  className="togo-tour-widget-title"
                  onClick={() => toggle("type")}
                >
                  Tour types <span className="icon">⌃</span>
                </h4>

                {open.type && (
                  <div className="inner_content">
                    <ul>
                      {[
                        "Group tour",
                        "Private tour",
                        "Daily tour",
                        "Package tour",
                      ].map((item, i) => (
                        <li key={i}>
                          <input type="checkbox" id={`mobile-${item}`} />
                          <label htmlFor={`mobile-${item}`}>{item}</label>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {/* Mobile Duration */}
              <Widget
                title="Duration"
                open={open.duration}
                toggle={() => toggle("duration")}
                items={[
                  "0 - 3 hours",
                  "3 - 5 hours",
                  "5 - 8 hours",
                  "8 - 12 hours",
                ]}
              />

              <button className="apply-filter-btn">Apply Filters</button>
            </div>
          )}

          {/* Recommend Tab Content */}
          {activeTab === "recommend" && (
            <div className="recommend-content">
              <h4>Recommended For You</h4>
              <p className="recommend-subtitle">Based on your preferences</p>

              <div className="recommended-packages">
                {recommendedPackages.map((pkg, index) => (
                  <div className="recommended-package-card" key={index}>
                    <div className="recommended-img">
                      <img src={pkg.img} alt={pkg.title} />
                    </div>
                    <div className="recommended-info">
                      <h5>{pkg.title}</h5>
                      <p className="location">{pkg.location}</p>
                      <span className="price">{pkg.price}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      <section className="home-testimonial bg-light home-blog">
        <div className="container">
          <div className="row mt-4">
            <div className="col-lg-10 offset-lg-1">
              <div className="content-box text-center">
                {/* Short Content */}
                <p className="intro-text">
                  Exploring Ladakh is a dream for many travelers, and for those
                  who value comfort and convenience, car tours are the perfect
                  choice. At Ladakh MotoDrive, we offer professionally designed
                  Ladakh car tour packages that allow you to experience the
                  beauty of the region without the physical challenges of
                  riding.....
                </p>

                {/* FULL CONTENT */}
                {showMore && (
                  <div className="full-content text-start">
                    <p>
                      Exploring Ladakh is a dream for many travelers, and for
                      those who value comfort and convenience, car tours are the
                      perfect choice. At Ladakh MotoDrive, we offer
                      professionally designed Ladakh car tour packages that
                      allow you to experience the beauty of the region without
                      the physical challenges of riding. Whether you are
                      traveling with family, friends, or as a couple, our tours
                      ensure a smooth and enjoyable journey through Ladakh’s
                      breathtaking landscapes. Our Leh Ladakh taxi tour services
                      are handled by experienced local drivers who understand
                      the terrain, weather conditions, and high-altitude routes.
                      This not only ensures safety but also allows you to relax
                      and enjoy the journey without worrying about navigation or
                      road conditions. From scenic drives through mountain
                      passes to peaceful moments by pristine lakes, our car
                      tours are designed to give you a complete Ladakh
                      experience in a comfortable way.
                    </p>

                    <h4>Who Should Do a Ladakh Car Trip?</h4>
                    <p>
                      Ladakh car tours are suitable for a wide range of
                      travelers, making them one of the most preferred travel
                      options in the region. These tours are ideal for families
                      traveling with children or elderly members, as they
                      eliminate the physical strain associated with long rides.
                      For friends and larger groups, our Ladakh group tours
                      offer a convenient and cost-effective way to explore
                      Ladakh together. First-time travelers often prefer car
                      tours as they provide a safe and guided introduction to
                      Ladakh’s unique geography and culture. With flexible
                      itineraries and comfortable vehicles, these tours ensure
                      that every traveler can enjoy Ladakh without stress.
                    </p>
                    <h4>Car Rental Services in Ladakh</h4>
                    <ul>
                      <li>
                        At Ladakh MotoDrive, we provide reliable and
                        well-maintained Ladakh car rental services to ensure a
                        smooth travel experience. Our fleet includes a variety
                        of vehicles suited for different group sizes and travel
                        needs. We offer comfortable SUVs such as Innova and
                        Scorpio, which are ideal for small families or groups.
                        For larger groups, we provide Tempo Travelers that offer
                        ample space and comfort during long journeys. All our
                        vehicles are specially maintained for high-altitude
                        conditions and challenging terrains, ensuring safety and
                        reliability throughout the trip. Each vehicle is driven
                        by an experienced local driver who is familiar with
                        Ladakh’s routes, road conditions, and weather patterns.
                      </li>
                    </ul>
                    <h4>Destinations Covered in the Ladakh Car Tour</h4>
                    <p>
                      Our Ladakh car tour packages are designed to cover all
                      major destinations, offering a complete and well-rounded
                      experience of Ladakh’s natural beauty and cultural
                      richness.
                    </p>
                    <p>
                      Leh serves as the starting point, featuring monasteries,
                      local markets, and cultural attractions, while also
                      allowing travelers to acclimatize before visiting
                      higher-altitude regions.
                    </p>
                    <p>
                      Nubra Valley is a key highlight, known for its cold desert
                      landscapes, sand dunes, and scenic views, reached by
                      crossing Khardung La, one of the highest motorable roads.
                    </p>
                    <p>
                      Pangong Lake is famous for its crystal-clear waters and
                      changing colors, providing a peaceful and breathtaking
                      experience that remains unforgettable for every traveler
                      visiting Ladakh.
                    </p>
                    <p>
                      Additional attractions include monasteries, Magnetic Hill,
                      and other scenic spots that enhance the overall journey
                      with unique cultural experiences and stunning landscapes.
                    </p>

                    <h4>Ladakh Car Tour Packages Cost </h4>
                    <p>
                      The Ladakh trip cost per person for car tours depends on
                      factors such as duration, accommodation type, and level of
                      customization. On average, packages start from around
                      ₹18,000 per person and can go higher based on the services
                      included. For families or groups, the overall cost may
                      vary depending on the number of travelers, the type of
                      vehicle, and hotel preferences.
                    </p>
                    <p>
                      Customized Leh Ladakh tour packages allow you to adjust
                      the itinerary and inclusions according to your budget and
                      requirements. Most packages include accommodation,
                      transportation, permits, and driver charges. However,
                      additional expenses such as meals, entry tickets, and
                      personal activities may vary depending on individual
                      preferences.
                    </p>

                    <h4>Benefits of Ladakh Car Tours</h4>
                    <p>
                      Choosing a car tour in Ladakh comes with several
                      advantages, especially for travelers who prioritize
                      comfort and safety.
                    </p>
                    <ul>
                      <li>
                        Car tours provide a relaxed travel experience, allowing
                        you to enjoy long journeys without physical strain. You
                        can sit back, take in the stunning views, and capture
                        memorable moments without worrying about driving.
                      </li>
                      <li>
                        Safety is another major benefit, as experienced drivers
                        handle challenging routes and high-altitude conditions
                        with ease. This is particularly important in Ladakh,
                        where road conditions can change quickly.
                      </li>
                      <li>
                        Flexibility is also a key advantage. You can customize
                        your itinerary, take breaks whenever needed, and explore
                        destinations at your own pace. This makes car tours
                        ideal for families, couples, and groups who want a
                        stress-free travel experience.
                      </li>
                    </ul>

                    <h4>Best Time to Visit Ladakh</h4>
                    <ul>
                      <li>
                        The best time for a car tour in Ladakh is between May
                        and September, when the region becomes fully accessible,
                        and travel conditions are at their best. During these
                        months, the major routes from Manali and Srinagar to Leh
                        remain open, allowing smooth and uninterrupted road
                        journeys. The weather stays relatively stable with clear
                        skies and pleasant daytime temperatures, making it ideal
                        for sightseeing and long drives.
                      </li>
                      <li>
                        This period allows travelers to comfortably explore
                        popular destinations such as Leh, Nubra Valley, and
                        Pangong Lake without facing extreme weather challenges.
                        The roads are in better condition, visibility is clear,
                        and the overall travel experience becomes more
                        enjoyable. While days are comfortable, nights can still
                        be cold due to high altitude, so proper clothing is
                        recommended. Overall, this season ensures a safe,
                        convenient, and memorable car travel experience in
                        Ladakh.
                      </li>
                    </ul>

                    <h4>FAQs</h4>
                    <ul>
                      <li>
                        <b>1. What is the cost of a car trip in Ladakh? :</b>
                        The cost of a car trip in Ladakh starts from around
                        ₹18,000 per person and may increase depending on the
                        duration, accommodation type, and level of customization
                        chosen.
                      </li>
                      <li>
                        <b>2. Is a car tour suitable for families? :</b>
                        Yes, car tours are the most suitable option for
                        families, especially those traveling with children or
                        elderly members, as they provide comfort, safety, and a
                        relaxed travel experience.
                      </li>
                      <li>
                        <b>3. Do you provide drivers with the vehicles? :</b>
                        Yes, all our car tour packages include experienced local
                        drivers who are familiar with Ladakh’s terrain, routes,
                        and weather conditions, ensuring a safe and smooth
                        journey.
                      </li>
                      <li>
                        <b>4. What vehicles are available for car tours? :</b>
                        We offer a range of vehicles, including SUVs like Innova
                        and Scorpio for small groups, as well as tempo travelers
                        for larger groups, ensuring comfort and convenience.
                      </li>
                      <li>
                        <b>5. Which destinations are covered in car tours? :</b>
                        Our car tours typically cover Leh, Nubra Valley, Pangong
                        Lake, and other major attractions, providing a complete
                        Ladakh experience with scenic beauty and cultural
                        exploration.
                      </li>
                    </ul>
                  </div>
                )}

                {/* Button */}
                <button
                  className="read-btn"
                  onClick={() => setShowMore(!showMore)}
                >
                  {showMore ? "Read Less ↑" : "Read More ↓"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CarTours;

/* ===============================
   REUSABLE WIDGET COMPONENT
================================*/

function Widget({ title, open, toggle, items }) {
  return (
    <div className="togo-tour-widget">
      <h4 className="togo-tour-widget-title" onClick={toggle}>
        {title} <span className="icon">⌃</span>
      </h4>

      {open && (
        <div className="inner_content">
          <ul>
            {items.map((item, i) => (
              <li key={i}>
                <input type="checkbox" id={item} />
                <label htmlFor={item}>{item}</label>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

/* ===============================
   PRICE RANGE COMPONENT
================================*/

function PriceRange() {
  const [min, setMin] = useState(0);
  const [max, setMax] = useState(2333);

  const MIN_GAP = 50;
  const MAX_VALUE = 5000;

  const handleMin = (e) => {
    const value = Math.min(Number(e.target.value), max - MIN_GAP);
    setMin(value);
  };

  const handleMax = (e) => {
    const value = Math.max(Number(e.target.value), min + MIN_GAP);
    setMax(value);
  };

  const progress = {
    left: `INR{(min / MAX_VALUE) * 100}%`,
    right: `INR{100 - (max / MAX_VALUE) * 100}%`,
  };

  return (
    <div className="price-widget togo-tour-widget">
      <h4 className="togo-tour-widget-title">
        Price range <span>⌃</span>
      </h4>

      {/* SLIDER */}
      <div className="range-slider">
        <div className="slider-track"></div>
        <div className="slider-progress" style={progress}></div>

        <input
          type="range"
          min="0"
          max={MAX_VALUE}
          value={min}
          onChange={handleMin}
          className="range-min"
        />

        <input
          type="range"
          min="0"
          max={MAX_VALUE}
          value={max}
          onChange={handleMax}
          className="range-max"
        />
      </div>

      {/* PRICE BOX */}
      <div className="price-inputs">
        <div>
          <label>Min. price</label>
          <input value={`$${min}`} readOnly />
        </div>

        <div>
          <label>Max. price</label>
          <input value={`$${max}`} readOnly />
        </div>
      </div>
    </div>
  );
}
